export const ADMIN_COGNITO_KEY = 'vda-admins-kajima';
